import axios from 'axios'
import { defineStore } from 'pinia'
import { notify } from '@kyvg/vue3-notification'
import SearchParams from '@/utils/search-params'

export const useAlbumStore = defineStore('album', {
  state: () => ({
    individualItem: null,
    massiveItems: null,
    deletedItems: []
  }),

  getters: {
    /**
     * Function that listen changes in deletedItems to filter
     * albums in all providers after searched.
     * @param state
     * @returns {{} | null}
     */
    filteredItems: state => {
      if (state.massiveItems) {
        let result = {}
        const keys = Object.keys(state.massiveItems)
        const values = Object.values(state.massiveItems)
          .map(provider => provider.filter(album =>
            !state.deletedItems.includes(album.upc)
          ))

        for (let i = 0; i < keys.length; i++) {
          result[keys[i]] = values[i]
        }

        return result
      } else {
        return null
      }
    }
  },

  actions: {
    async findAlbumById(data) {
      await axios.get(process.env.VUE_APP_API_URL + 'release/?' +
        SearchParams(data.type, data.value))
        .then(result => {
          this.individualItem = result.data.data
        })
        .catch(err => {
          notify({
            text: err.response.data.message,
            type: 'error',
            duration: 3000,
            ignoreDuplicates: true
          })
        })
    },

    async findAlbums(data) {
      await axios.post(process.env.VUE_APP_API_URL + 'releases/', {
        [data.type ? 'isrcs': 'upcs']: data.value
      })
        .then(result => {
          this.massiveItems = result.data.data
        })
        .catch(err => {
          notify({
            text: err.response.data.message,
            type: 'error',
            duration: 3000,
            ignoreDuplicates: true
          })
        })
    },

    async syncAlbum(data) {
      await axios.post(process.env.VUE_APP_API_URL +  'sync/', data)
        .then(result => {
          notify({
            text: result.data.message,
            type: 'success',
            duration: 4000,
            ignoreDuplicates: true
          })
        })
        .catch(err => {
          notify({
            text: err.response.data.message,
            type: 'error',
            duration: 3000,
            ignoreDuplicates: true
          })
        })
    },

    addToDeletedItems(id) {
      this.deletedItems.push(id)
    }
  }
})
